import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import PropTypes from "prop-types";

function CertificadoMigracaoModal({ modalHook, concluirEtapa }) {
  const { certificadoMigracaoModal, setCertificadoMigracaoModal } = modalHook;

  return (
    <CommonModal
      title="Certificado digital e-CNPJ A1"
      is_open_modal={certificadoMigracaoModal}
      set_is_open_modal={setCertificadoMigracaoModal}
      size="md"
      buttons={
        <CommonButton
          key={`novo-processo`}
          color="success"
          onClick={concluirEtapa}
        >
          Concluir tarefa
        </CommonButton>
      }
      customDeny={<></>}
    >
      <div className="row">
        <div className="col-lg-12 mb-3">
          <p className="text-body">
            O e-CNPJ é o certificado da pessoa jurídica e, como os processos são
            eletrônicos, precisamos que sua empresa tenha o certificado e-CNPJ
            para a emissão de notas fiscais eletrônicas e para dar veracidade ao
            envio das obrigações acessórias que a empresa deve cumprir
            mensalmente com o fisco. Sem ele a empresa corre o risco de ter
            atrasos em suas obrigações e, com isso, pode receber multas.
          </p>
        </div>
      </div>
    </CommonModal>
  );
}

CertificadoMigracaoModal.propTypes = {
  modalHook: PropTypes.shape({
    certificadoMigracaoModal: PropTypes.bool.isRequired,
    setCertificadoMigracaoModal: PropTypes.func.isRequired,
  }).isRequired,
  concluirEtapa: PropTypes.func.isRequired,
};

export default CertificadoMigracaoModal;
